import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions';

export interface ZoneFilters {
  search?: string;
  projectId?: string;
  status?: string;
}

export const zoneListService = {
  async getZones(companyId: string, filters: ZoneFilters) {
    if (!companyId) return [];

    let query = supabase
      .from('project_zones')
      .select(`
        id,
        zone_code,
        zone_name,
        zone_type,
        area_m2,
        status_code,
        updated_at,
        description,
        parent_zone_id,
        project_id,
        project:projects (id, code, name),
        parent_zone:project_zones!parent_zone_id (id, zone_name)
      `)
      .eq('company_id', companyId)
      .order('updated_at', { ascending: false });

    if (filters.projectId && filters.projectId !== 'all') {
      query = query.eq('project_id', filters.projectId);
    }
    
    if (filters.status && filters.status !== 'all') {
      query = query.eq('status_code', filters.status);
    }

    if (filters.search) {
      query = query.or(`zone_name.ilike.%${filters.search}%,zone_code.ilike.%${filters.search}%`);
    }

    const { data, error } = await query;
    
    if (error) throw error;
    
    return data || [];
  },

  async getProjects(companyId: string) {
    if (!companyId) return [];
    
    const { data, error } = await supabase
      .from('projects')
      .select('id, code, name')
      .eq('company_id', companyId)
      .is('deleted_at', null)
      .order('name');
      
    if (error) throw error;
    return data || [];
  }
};
